import { ChevronRight } from '@ixigo/icons';
import Button from '@ixigo/iui/Button';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { ActiveChatInfoProps } from './index.types';

const ActiveChatInfo: FC<ActiveChatInfoProps> = ({ actorAvatarUrl, actorName, lastMessage }) => (
    <ListItem disablePadding className='gap-10 hover:!bg-inherit'>
        <ListItemIcon>
            <img src={actorAvatarUrl} alt='tara' className='w-40 h-40' />
        </ListItemIcon>
        <ListItemText
            className='overflow-hidden'
            secondary={
                <Typography
                    as='div'
                    variant='body-xs'
                    fontWeight='normal'
                    className='overflow-hidden text-ellipsis text-charcoal-600 line-clamp-1'
                    dangerouslySetInnerHTML={{ __html: lastMessage }}
                />
            }
        >
            <span className='flex flex-row items-center justify-center'>
                <span>{actorName}</span>
            </span>
        </ListItemText>
        <ListItemIcon>
            <Button variant='solid' color='brand' size='sm' className='rounded-full flex justify-center'>
                <Typography className='pl-5'>Chat</Typography>
                <ChevronRight fontSize={20} />
            </Button>
        </ListItemIcon>
    </ListItem>
);

export default ActiveChatInfo;
